module.exports = __webpack_public_path__ + "pl.svg?1f4f8ec32bba1e4e2ec3f4c5fc14efc6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/pl.svg
// module id = 1567
// module chunks = 0